import moment from "moment-timezone";

/**'DD/MM/YYYY HH:mm'*/
export function formatDate(value, format = 'DD/MM/YYYY HH:mm') {
  if (!value) return '-';
  //  timezone'unu bul ve   kullan
  const userTimezone = moment.tz.guess();
  return moment.utc(String(value)).tz(userTimezone).format(format);
}

/**(örn: "1dk 50sn" veya "2sa 15dk 30sn")*/
export function timeSecondConvert(seconds, showSeconds = true) {
  if (!seconds || seconds <= 0) return '0sn';
  
  const totalSeconds = Math.floor(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const remainingSeconds = totalSeconds % 60;
  
  let result = [];
  
  if (hours > 0) {
    result.push(`${hours}sa`);
  }
  
  if (minutes > 0) {
    result.push(`${minutes}dk`);
  }
  
  if (showSeconds && remainingSeconds > 0) {
    result.push(`${remainingSeconds}sn`);
  }
  
  return result.length > 0 ? result.join(' ') : '0sn';
}
/**(DD/MM/YYYY)*/
export function formatDateOnly(value) {
  if (!value) return '-';
  const userTimezone = moment.tz.guess();
  return moment.utc(String(value)).tz(userTimezone).format('DD/MM/YYYY');
}

/**(HH:mm)*/
export function formatTimeOnly(value) {
  if (!value) return '-';
  const userTimezone = moment.tz.guess();
  return moment.utc(String(value)).tz(userTimezone).format('HH:mm');
}

/**(years, months, weeks, days, hours, minutes, seconds)*/
export function addToDate(date, amount, unit = 'days') {
  if (!date) return null;
  return moment(date).add(amount, unit).format('YYYY-MM-DD HH:mm:ss');
}

/** "2 saat önce", "3 gün önce" gibi */
export function timeAgo(date) {
  if (!date) return '-';
  const userTimezone = moment.tz.guess();
  return moment.utc(date).tz(userTimezone).fromNow();
}

/**
 * Yerel tarih/saat stringini UTC'ye çevirir
 * Backend'e gönderilmeden önce kullanılmalı
 * @param {string} localDateString - "YYYY-MM-DD HH:mm:ss" formatında yerel tarih
 * @returns {string} - "YYYY-MM-DD HH:mm:ss" formatında UTC tarih
 */
export function convertLocalToUTC(localDateString) {
  if (!localDateString) return null;
  const userTimezone = moment.tz.guess();
  return moment.tz(localDateString, 'YYYY-MM-DD HH:mm:ss', userTimezone)
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
}

/**
 * UTC tarih/saat stringini yerel zamana çevirir
 * Backend'den gelen veri gösterilirken kullanılmalı
 * @param {string} utcDateString - "YYYY-MM-DD HH:mm:ss" formatında UTC tarih
 * @returns {string} - "YYYY-MM-DD HH:mm:ss" formatında yerel tarih
 */
export function convertUTCToLocal(utcDateString) {
  if (!utcDateString) return null;
  const userTimezone = moment.tz.guess();
  return moment.utc(utcDateString, 'YYYY-MM-DD HH:mm:ss')
    .tz(userTimezone)
    .format('YYYY-MM-DD HH:mm:ss');
}

